import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import {ErrorBoundary} from './components';
import {PRODUCT_NAME} from '../src/product';
import './styles.css';

const element = document.getElementById('root');
if (!element) throw new Error(`${PRODUCT_NAME} requires its root element.`);
createRoot(element).render(<React.StrictMode><ErrorBoundary><App/></ErrorBoundary></React.StrictMode>);
